<script context="module">
    /*
	This plugins was created based on the Prism line-numbering plugin.
	This plugin aims to number all lines and is independent of highlighting.
*/
(function(){

if(!window.Prism || !document.querySelectorAll) {
	return;
}

function $$(expr, con) {
	return Array.prototype.slice.call((con || document).querySelectorAll(expr));
}

function numberLines(env) {
    let lines = env.highlightedCode.split("\n");

    env.highlightedCode = "<ol><li>" + lines.join("\n</li><li>") + "</li></ul>";

    env.element.innerHTML = env.highlightedCode;
}

Prism.hooks.add('after-highlight', function(env) {
	var pre = env.element.parentNode;

	numberLines(env);
});

})();

</script>
<script>
    import {CodeJar} from 'codejar';
    //import Prism from 'prismjs';
    import {debounce} from "lodash-es";

    // Import line numbers helper.
    import {withLineNumbers} from 'codejar/linenumbers';

    let wrapper;

    function codeJar(el) {
        let editor = CodeJar(el, withLineNumbers(Prism.highlightElement));

        wrapper = el.parentNode;
        el.contentEditable = !readonly;

        const debouced_update = debounce(() => {
            value = editor.toString();
        }, 500);

        editor.onUpdate(code => {
            debouced_update();
        })

        return {
            update: (code) => {
                if (code != editor.toString()) {
                    editor.updateCode(code);
                }
            },
            destroy: () => {
                editor.destroy();

                // remove leftover wrapper
                wrapper.parentNode.removeChild(wrapper);
            }
        }
    }


    export let value = "";
    export let lang = "";
    export let readonly = false;
</script>

<div class="source line-numbers" class:readonly>
    <pre class="language-{lang}" use:codeJar={value} contenteditable={!readonly}>
        {value}
    </pre>
</div>

<style>
    .source {
        max-width: 800px;
    }
    .source :global(pre) {
        white-space: pre-wrap !important;
    }

    .source :global(ol li) {
        counter-increment: line;
    }

    .source :global(ol li:before) {
        content: counter(line);
        position: relative;
        left: -1.6em;
    }

    .source :global(ol) {
        list-style-type: none;
        counter-reset: line;
    }
</style>